import { object, string, array, number, boolean } from 'yup'
import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'
import { ISearchSupplier } from '../../interfaces/Supplier/Supplier'

export const dataGridSettingsDispatchOt: DataGridSettings = {
  spacing: 2,
  sortingMode: 'single',
  columns: [
    {
      title: 'Imagen',
      dataField: 'skuImage',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'SKU/EAN13',
      dataField: 'sku',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: true
    },
    {
      title: 'Nombre de producto',
      dataField: 'skuName',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: true
    },
    {
      title: 'Cantidad',
      dataField: 'quantity',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: true
    },
    {
      title: 'Ruta Picking',
      dataField: 'pickingRouteIds',
      xs: 12,
      sm: 6,
      lg: 2,
      allowSorting: false
    },
    {
      title: 'Pack',
      dataField: 'packSkuDun',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'Unidades',
      dataField: 'quantityDun',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    },
    {
      title: 'Acción',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 1,
      allowSorting: false
    }
  ]
}

export const searchInitialState: ISearchSupplier = {
  searchField: '',
  searchValue: ''
}

export const createInitialValue = {
  id: 0,
  warehouseCode: '',
  postalCode: '',
  warehouseDescription: '',
  warehouseAdrress: '',
  warehouseName: '',
  warehouseSchedule: [],
  active: false
}

export const supplierValidationSchema = object({
  rutDniSupplier: string()
    .required('El campo rut de proveedor es requerido.')
    .max(50, 'Máximo 50 caracteres.'),
  supplierName: string()
    .trim()
    .required('El campo nombre de proveedor es requerido.')
    .max(50, 'Máximo 50 caracteres.'),
  warehousesId: array(),
  supplierOrigin: array(
    object({
      supplierId: number(),
      supplierOriginName: string().required('Debe ingresar un origen'),
      productControlPercentage: number().required(
        'Debe ingresar un control de porcentaje'
      ),
      draft: boolean().required('Debe ingresar un borrador'),
      comments: string().required('Debe ingresar un comentario')
    })
  )
})
